<mat-card style="border-color: #5775a8;">
  <mat-card-content>
    <mat-card>
      <div class="flex flex-col w-full">
        <business-businessComplaintList (closeEvent)="close()"></business-businessComplaintList>
        <div style="padding-right: 20px;">
          <button mat-raised-button (click)="close()" class="m-8 container" style="background-color: #5775a8;;">
            <span style="color: white;">Return</span>
          </button>
        </div>

      </div>
    </mat-card>
  </mat-card-content>

</mat-card>